import baseEditForm from 'formiojs/components/_classes/component/Component.form';
import TextfieldEditData from 'formiojs/components/textfield/editForm/TextField.edit.data';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: TextfieldEditData,
    },
    {
      key: 'data',
      ignore: true,
    },
    {
      key: 'validation',
      ignore: true,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 100,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 200,
          type: 'textfield',
          label: 'Tooltip Title',
          key: 'tooltipTitle',
          input: true,
        },
        {
          weight: 300,
          type: 'textfield',
          label: 'Translation Id',
          key: 'translationId',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
